@if (resAsync | async) {
  <div class="containerStepper">
    <mat-vertical-stepper
      [linear]="true"
      orientation="vertical"
      #stepper
      (selectionChange)="stepperSelectionChange(stepper, $event)"
    >
      <mat-step label="{{ res.get('WizardWelcome') }}" [editable]="processState !== ProcessState.Exporting">
        <div style="display: flex">
          <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 600px">
            <div>
              <h1>{{ exportConfig.welcomePage.title }}</h1>
            </div>
          </div>
        </div>
        <div fxLayout="row">
          <div fxLayoutAlign="center center">
            <p>
              {{ exportConfig.welcomePage.description }}
            </p>
          </div>
        </div>
        <hr />
        <div fxLayout="row" style="float: right">
          <div fxFlex="30">
            <button mat-button matStepperNext>{{ res.get('ButtonTextContinue') }}</button>
          </div>
        </div>
      </mat-step>
      @for (page of exportConfig?.contentPages; track page) {
        <mat-step [completed]="false" [editable]="processState !== ProcessState.Exporting" label="{{ page.title }}">
          <div fxLayout="row">
            <div fxLayoutAlign="center center">
              <p>
                {{ page.description }}
              </p>
            </div>
          </div>
          <content-page-wrapper
            [component]="page.component"
            [transferObject]="exportConfig.transferObject"
            (componentInstantiated)="page.componentInstance = $event"
          ></content-page-wrapper>
          <hr />
          <div fxLayout="row" style="float: right">
            <div fxFlex="30">
              <button mat-button matStepperPrevious>{{ res.get('ButtonTextBack') }}</button>
              <button mat-button (click)="moveStep(stepper, page.componentInstance)">
                {{ res.get('ButtonTextContinue') }}
              </button>
            </div>
          </div>
        </mat-step>
      }
      <mat-step label="Export">
        @if (processState === ProcessState.BeforeFinishClick) {
          <div>
            <div fxLayout="row">
              <div fxLayoutAlign="center center">
                <p>
                  {{ res.get('WizardInformationReady') }}
                </p>
              </div>
            </div>
            <div fxLayout="row" style="float: right">
              <div fxFlex="30">
                <button mat-button matStepperPrevious>{{ res.get('ButtonTextBack') }}</button>
                <button mat-button (click)="finishClick()">{{ res.get('ButtonTextStartExecution') }}</button>
              </div>
            </div>
          </div>
        } @else {
          <div fxLayout="row">
            <div fxLayoutAlign="center center">
              <dx-progress-bar
                class="dx-field-label export-progress-bar"
                [min]="0"
                [max]="1"
                [value]="progressPercentage"
                [statusFormat]="progressStatusFormat"
              ></dx-progress-bar>
            </div>
          </div>
          <div fxLayout="row" style="float: right">
            <div fxFlex="30">
              <button mat-button [disabled]="processState === ProcessState.Exporting" (click)="moveBack()">
                {{ res.get('ButtonTextBack') }}
              </button>
              <!--<button mat-button width="200px" (click)="retryButtonClick()">
              {{ retryButtonCaption }}
            </button>-->
              <abcButton
                [id]="'retryButton'"
                [width]="'200px'"
                [value]="retryButtonCaption"
                (click)="retryButtonClick()"
              ></abcButton>
            </div>
          </div>
        }
      </mat-step>
    </mat-vertical-stepper>
  </div>
}
